<div class="modal-header">
  <h5 class="modal-title" id="partial-send-confirm-title">
    <i class="fa fa-exclamation-triangle"></i>
    Saldo insuficiente
    <span class="sub">Confirme para continuar o agendamento</span>
  </h5>
  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="cancel()"
    data-testid="btn-partial-close">
    <i class="fa fa-times"></i>
  </button>
</div>

<div class="modal-body" data-testid="partial-send-body">
  <div class="notice notice--warning" data-testid="partial-send-cost">
    <i class="fa fa-credit-card"></i>
    <div class="notice__body">
      Saldo insuficiente para o envio completo. Este envio custa ~<strong>{{ confirmation.cost }}</strong>
      e você tem <strong>{{ confirmation.available }}</strong> disponíveis.
    </div>
  </div>

  <ng-container [ngSwitch]="outcome">
    <p *ngSwitchCase="'partial_cancel'" data-testid="partial-send-outcome">
      Se na hora do envio não houver saldo para tudo, ele sai <strong>parcial</strong>
      (~{{ partialQuantity }} {{ unitLabel }}, pelo saldo disponível) e o restante é cancelado.
    </p>
    <p *ngSwitchCase="'partial_wait'" data-testid="partial-send-outcome">
      Se na hora do envio não houver créditos para tudo, saem ~{{ partialQuantity }} {{ unitLabel }}
      e o restante fica aguardando uma recarga.
    </p>
    <p *ngSwitchCase="'wait_all'" data-testid="partial-send-outcome">
      Se na hora do envio não houver créditos, as {{ unitLabel }} ficam aguardando uma recarga.
    </p>
    <p *ngSwitchCase="'cancel_all'" data-testid="partial-send-outcome">
      Se na hora do envio não houver {{ fundsLabel }} para tudo, o envio é cancelado — recarregue antes da data.
    </p>
  </ng-container>

  <p class="partial-send-question">Deseja agendar mesmo assim?</p>

  <!-- Outra aba: o formulário preenchido e este modal continuam aqui. -->
  <a class="sf-btn sf-btn--ghost sf-btn--sm" [href]="rechargeHref" target="_blank" rel="noopener"
    data-testid="btn-partial-recharge">
    <i class="fa fa-plus-circle"></i>
    Recarregar (abre em outra aba)
  </a>
</div>

<div class="modal-footer">
  <button type="button" class="sf-btn sf-btn--secondary push" (click)="cancel()" data-testid="btn-partial-cancel">
    Cancelar
  </button>
  <button type="button" class="sf-btn sf-btn--primary" (click)="confirm()" data-testid="btn-partial-confirm">
    Agendar mesmo assim
  </button>
</div>
